// 서버 에러코드 체계 기반 에러코드-메시지 매핑 유틸
export const ERROR_CODE_MAP = {
  // 인증/인가 관련 (1001~1099)
  '1001': 'JWT 토큰이 유효하지 않습니다.',
  '1002': 'JWT 토큰이 만료되었습니다.',
  '1003': 'JWT 토큰이 누락되었습니다.',
  '1004': 'JWT 토큰 형식이 잘못되었습니다.',
  '1005': 'JWT 서명이 유효하지 않습니다.',
  '1006': 'JWT 클레임이 유효하지 않습니다.',
  // 컨텐츠/보안 관련 (2001~2099)
  '2001': '부적절한 컨텐츠가 감지되었습니다.',
  '2002': '욕설/비속어가 감지되었습니다.',
  '2003': '스팸 컨텐츠가 감지되었습니다.',
  '2004': '저작권 침해 컨텐츠입니다.',
  '2005': '폭력적 컨텐츠가 감지되었습니다.',
  '2006': '성인 컨텐츠가 감지되었습니다.',
  // 개인정보/마스킹 (2101~2199)
  '2101': '개인정보가 노출되었습니다.',
  '2102': '민감한 데이터가 감지되었습니다.',
  '2103': '개인식별정보(PII)가 감지되었습니다 ',
  '2104': '금융정보가 노출되었습니다.',
  '2105': '의료정보가 노출되었습니다.',
  '2106': '파일 내용에 PII가 감지되었습니다.',
  // 탈옥/보안 우회 (2201~2299)
  '2201': '시스템 탈옥 시도가 감지되었습니다',
  '2202': '보안 우회 시도가 감지되었습니다.',
  '2203': '악성 프롬프트가 감지되었습니다.',
  '2204': '인젝션 공격 시도가 감지되었습니다.',
  // 파일 처리 (3001~3099)
  '3001': '파일을 찾을 수 없습니다.',
  '3002': '파일 ID가 유효하지 않습니다.',
  '3003': '파일 액세스 권한이 없습니다.',
  '3004': '파일이 손상되었습니다.',
  '3005': '지원하지 않는 파일 형식입니다.',
  '3006': '파일 크기 제한을 초과했습니다.',
  // 업로드 제한 (3101~3199)
  '3101': '업로드 파일 수량 제한을 초과했습니다.',
  '3102': '일일 업로드 제한을 초과했습니다.',
  '3103': '월간 업로드 제한을 초과했습니다.',
  '3104': '사용자별 파일 보관 한도를 초과했습니다.',
  // 암호화 (4001~4099)
  '4001': '암호화에 실패했습니다.',
  '4002': '복호화에 실패했습니다.',
  '4003': '잘못된 암호화 키입니다.',
  '4004': '지원하지 않는 암호화 알고리즘입니다.',
  '4005': '암호화 키 생성에 실패했습니다.',
  '4006': '해시 생성에 실패했습니다.',
  '4007': '서명 검증 실패했습니다.',
  // 키 저장소 (4101~4199)
  '4101': '키 저장소 접근에 실패했습니다.',
  '4102': '키를 찾을 수 없습니다.',
  '4103': '키 저장에 실패했습니다.',
  '4104': '키 삭제에 실패했습니다.',
  '4105': '키 저장소 비밀번호가 잘못되었습니다.',
  // 저장소 처리 (5001~5099)
  '5001': '저장소 연결에 실패했습니다.',
  '5002': '저장소 용량이 부족합니다.',
  '5003': '저장소 읽기에 실패했습니다.',
  '5004': '저장소 쓰기에 실패했습니다.',
  '5005': '저장소 삭제에 실패했습니다.',
  '5006': '저장소 권한이 없습니다.',
  '5007': '저장소 작업이 타임아웃되었습니다.',
  // 게이트웨이/네트워크 (6001~6099)
  '6001': '게이트웨이 연결에 실패했습니다.',
  '6002': '게이트웨이 타임아웃이 발생했습니다.',
  '6003': '잘못된 게이트웨이 응답입니다.',
  '6004': '게이트웨이 서비스를 사용할 수 없습니다.',
  '6005': '게이트웨이 인증에 실패했습니다.',
  '6006': '게이트웨이 요청 제한을 초과했습니다.',
  // 토큰 (7001~7099)
  '7001': '요청 토큰 제한을 초과했습니다.',
  '7002': '응답 토큰 제한을 초과했습니다.',
  '7003': '일일 토큰 사용량을 초과했습니다.',
  '7004': '월간 토큰 사용량을 초과했습니다.',
  '7005': '사용자별 토큰 할당량을 초과했습니다.',
  '7006': '컨텍스트 길이 제한을 초과했습니다.',
  '7007': '요청 횟수 제한을 초과했습니다.',
  // 시스템 (8001~8099)
  '8001': '내부 서버 오류가 발생했습니다.',
  '8002': '서비스가 일시적으로 중단되었습니다.',
  '8003': '데이터베이스 연결 오류가 발생했습니다.',
  '8004': '외부 API 호출에 실패했습니다.',
  '8005': '설정 오류가 발생했습니다.',
  // 기타 (9001~9099)
  '9001': '알 수 없는 오류가 발생했습니다.',
  '9002': '요청 형식이 잘못되었습니다.',
  '9003': '필수 파라미터가 누락되었습니다.',
  '9004': '잘못된 파라미터 값입니다.',
  // 특수 (2301)
  '2301': 'Request banword detected.'
};
export function getErrorMessage(code) {
  return ERROR_CODE_MAP[code] || '알 수 없는 오류가 발생했습니다.';
} 